import { useEffect, useRef, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import appConfig from '@/configs/app.config'
import { useAuth } from '@/auth'
import { isKeycloakEnabled } from '@/auth/keycloak'
import { ssoLogin } from '@/auth/sso'

const { unAuthenticatedEntryPath } = appConfig

const ProtectedRoute = () => {
    const { authenticated } = useAuth()
    const ssoEnabled = isKeycloakEnabled()
    const started = useRef(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!ssoEnabled || authenticated || started.current) return

        started.current = true

        void ssoLogin().catch(() => {
            started.current = false
            setError(true)
        })
    }, [authenticated, ssoEnabled])

    if (authenticated) {
        return <Outlet />
    }

    // SSO disabled (VITE_KEYCLOAK_ENABLED !== 'true'): use the existing HRMS login.
    if (!ssoEnabled) {
        return <Navigate replace to={unAuthenticatedEntryPath} />
    }

    if (error) {
        return (
            <div role="alert">
                <p>Unable to connect to SSO.</p>
                <button onClick={() => window.location.reload()}>
                    Try again
                </button>
            </div>
        )
    }

    return <p>Redirecting to SSO...</p>
}

export default ProtectedRoute
